import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params//valid-params";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { useChampionItems } from "@ugg/shared/api/requests/champions/items";
import { getItems } from "@ugg/shared/api/data-parser/champions/items";
import { ItemsTable } from "./ItemsTable";
import { ChampionProfilePagePlaceholder } from "@ugg/shared/components/Champions/ChampionProfilePagePlaceholder";
import { ChampionProfilePageError } from "@ugg/shared/components/Champions/ChampionProfilePageError";
import { normalizeRole } from "@ugg/shared/utils/role-helpers";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";

export function ItemsTableContainer() {
  const { championId, role } = useChampionProfileContext();

  const queryParams = useQueryString();
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(CHAMPION_PAGES.ITEMS, queryParams, true);
  const { data, loading, error } = useChampionItems(championId, { params: validatedQueryParams, ssr: true });
  const championItems = getItems(data, { ...validatedQueryParams, role: normalizeRole(role || "") });

  if (loading) {
    return <ChampionProfilePagePlaceholder className="w-full" />;
  } else if (error || !championItems) {
    return <ChampionProfilePageError className="w-full" />;
  }

  return (
    <div className="flex w-full">
      <ItemsTable
        className="w-full flex-1 flex flex-col gap-[12px]"
        patch={validatedQueryParams.patch}
        championItems={championItems}
      />
    </div>
  );
}
